import FormattedMessage from 'I18n/components/FormattedMessage';
import { MarketplaceIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { View } from 'foundations-components/transitional/components/View';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Paths } from '../../constants/paths';
import { SearchBarContainer } from '../../search-bar/containers/SearchBarContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function HeaderView() {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    backgroundColor: "fill-surface-default",
    blockSize: "100px",
    "data-test-id": "header",
    flexDirection: "row",
    justifyContent: "space-between",
    insetBlockStart: "0",
    position: "sticky",
    zIndex: "1",
    children: [/*#__PURE__*/_jsx(UIRouterLink, {
      to: Paths.HOME,
      use: "unstyled",
      children: /*#__PURE__*/_jsx(MediaObject, {
        align: "center",
        itemLeft: /*#__PURE__*/_jsx(IconHolder, {
          color: "fill-primary-default",
          icon: MarketplaceIcon,
          margin: "0",
          padding: "0",
          size: "600"
        }),
        spacing: "none",
        children: /*#__PURE__*/_jsx(Text, {
          as: "h1",
          typography: "heading-300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.headers.title"
          })
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      inlineSize: "600px",
      children: /*#__PURE__*/_jsx(SearchBarContainer, {})
    }), /*#__PURE__*/_jsx(View, {})]
  });
}